import React, { Component } from "react";
import VerificarDocumentoIntegranteComponent from "../../../components/personaReferencia/verificarDocumentoIntegrante/VerificarDocumentoIntegranteComponent";
import { verificarDocumentoIntegranteStore } from "./VerificarDocumentoIntegrante.store";
import { verificarDocumentoIntegranteDispatcher } from "./VerificarDocumentoIntegrante.dispatcher";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import ModalFrame from "../../../../toolkit/modalFrame";

interface Props {
  idMembresiaSocioPersona: number;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface State {}

@ReduxConnect(
  verificarDocumentoIntegranteStore,
  verificarDocumentoIntegranteDispatcher
)
export default class VerificarDocumentoIntegranteModal extends Component<
  Props,
  State
> {
  state = {};

  render() {
    return (
      <ModalFrame
        title="Verificar Documento del Integrante"
        isOpen={this.props.isOpen}
        toggle={this.props.onClose}
        size="xl"
      >
        <VerificarDocumentoIntegranteComponent {...(this.props as any)} />
      </ModalFrame>
    );
  }
}
